import { Settings } from './chart-defaults';

const ChartDefaults = {
  colors: Settings.colors,
  chartAreaCeiling: Settings.chartAreaCeiling,
  chartAreaFloor: Settings.chartAreaFloor,
};

export default ChartDefaults;
